<template>
  <h1 class="hero-title">
    <slot />
  </h1>
</template>

<style scoped>
.hero-title {
  font-size: 25px;
  line-height: 1.4;
  font-weight: 700;
  letter-spacing: 0.01em;
  color: var(--font-black);
}
</style>
